<template>
  <a-modal
    :visible="visible"
    :mask-closable="false"
    :confirm-loading="loading"
    width="640px"
    forceRender
    @ok="handleOk"
    @cancel="handleCancel"
    :ok-text="isEdit ? '保存' : '立即创建'"
    cancel-text="取消"
    centered
  >
    <span slot="title">
      <div class="modal-title">{{ isEdit ? '编辑客户端' : '新增客户端' }}</div>
      <div class="modal-extra-tip" v-if="!isEdit">创建专属客户端，系统将自动生成 Secret</div>
    </span>

    <a-form :form="form" layout="vertical" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }">
      <!-- ClientId 编辑时展示 -->
      <a-form-item label="ClientId">
        <a-input
          v-decorator="['clientId', { rules: [{ required: true, message: '请输入 ClientId' }] }]"
          :disabled="Boolean(isEdit)"
          :maxLength="128"
          placeholder="请输入 ClientId，限 128 个字符"
          style="width: 100%"
          @blur="handleBlur"
        ></a-input>
      </a-form-item>

      <a-form-item label="客户端名称">
        <a-input
          v-decorator="['clientName', { rules: [{ required: true, message: '请输入客户端名称', whitespace: true }] }]"
          placeholder="请输入客户端名称，限 50 字"
          :max-length="50"
          show-count
          style="width: 100%"
        ></a-input>
      </a-form-item>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="客户端分类">
            <a-select
              v-decorator="['clientCategory', { rules: [{ required: true, message: '请选择客户端分类' }] }]"
              placeholder="请选择"
              style="width: 100%"
              @change="handleCategoryChange"
            >
              <a-select-option v-for="item in categoryOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="客户端类型">
            <a-select
              v-decorator="['clientType', { rules: [{ required: true, message: '请选择客户端类型' }] }]"
              placeholder="请选择客户端分类"
              style="width: 100%"
            >
              <a-select-option v-for="item in currentTypeOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="描述">
        <a-textarea
          v-decorator="['description']"
          placeholder="请输入客户端备注信息，限 500 字"
          :rows="4"
          :max-length="500"
          show-count
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { CLIENT_CATEGORIES, getTypesByCategory } from '../clientConstants.js'

export default {
  name: 'AddClientModal',
  props: {
    visible: { type: Boolean, default: false },
    record: { type: Object, default: null },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      categoryOptions: CLIENT_CATEGORIES,
      currentTypeOptions: [], // 根据分类动态更新
      checkAppId: false,
    }
  },
  computed: {
    isEdit() {
      return this.record && this.record.id
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm()
      }
    },
  },
  methods: {
    initForm() {
      this.checkAppId = false
      if (this.isEdit) {
        const category = this.record.clientCategory
        this.currentTypeOptions = getTypesByCategory(category)
        // $nextTick 确保 v-decorator 字段已渲染注册后再 setFieldsValue
        this.$nextTick(() => {
          this.form.setFieldsValue({
            clientId: this.record.clientId,
            clientName: this.record.clientName,
            clientCategory: category,
            clientType: this.record.clientType,
            description: this.record.description,
          })
        })
      } else {
        this.currentTypeOptions = []
        this.form.resetFields()
      }
    },
    handleCategoryChange(val) {
      // 切换分类时更新可选类型并清空已选类型
      this.currentTypeOptions = getTypesByCategory(val)
      this.form.setFieldsValue({ clientType: undefined })
    },
    handleOk() {
      if (this.checkAppId) {
        this.$message.warning('该AppID已存在')
        return
      }

      this.form.validateFields((err, values) => {
        if (err) return
        this.loading = true
        const payload = {
          // dto: {
            clientId: values.clientId,
            clientName: values.clientName,
            clientCategory: values.clientCategory,
            clientType: values.clientType,
            description: values.description,
            id: this.record ? this.record.id : undefined,
          // }
        }

        const req = this.isEdit
          ? this.$api.updateAppClient(payload)
          : this.$api.addAppClient(payload)

        req.then((res) => {
          this.loading = false
          if (res && res.code == 0) {
            this.$message.success(this.isEdit ? '保存成功' : '创建成功')
            this.$emit('close')
            this.$emit('refresh')
          } else {
            this.$message.error(res && res.message ? res.message : '操作失败')
          }
        }).catch(() => {
          this.loading = false
          this.$message.success(this.isEdit ? '保存成功' : '创建成功（模拟）')
          this.$emit('close')
          this.$emit('refresh')
        })
      })
    },
    handleCancel() {
      this.$emit('close')
    },

    handleBlur() {
      const clientId = this.form.getFieldValue('clientId')
      if (!clientId) return

      // checkClientId 校验输入的ClientId唯一性
      this.$api.checkClientId(clientId, this.record ? this.record.clientId : undefined).then((res) => {
        if (res && res.code == 0 && !res.data.valid) {
          this.$message.warning(res.data.message)
          this.checkAppId = true
        } else {
          this.checkAppId = false
        }
      }).catch(() => {
        this.$message.warning('该ClientId已存在')
      })
    }
  },
}
</script>

<style lang="less" scoped>
.modal-title {
  font-size: 16px;
  font-weight: bold;
}

.modal-extra-tip {
  font-size: 12px;
  color: #999;
}
</style>
